export default __webpack_public_path__ + "static/media/cover_placeholder_1x.c17f1dd4.webp";